
 export enum ManagementOfProceedsMethod {
	SEGREGATED_ACCOUNT = 'SEGREGATED_ACCOUNT',
	INTERNAL_TRACKING = 'INTERNAL_TRACKING',
	SUB_PORTFOLIO = 'SUB_PORTFOLIO',
	OTHER_METHOD = 'OTHER_METHOD',
}
